module.exports = __webpack_public_path__ + "img/background-light.6761058.png";